/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespFollowTopButton_user = {
    readonly serviceId: string | null;
    readonly favorites: {
        readonly " $fragmentRefs": FragmentRefs<"FollowButton_favoritesConnection">;
    } | null;
    readonly " $refType": "SbRespFollowTopButton_user";
};
export type SbRespFollowTopButton_user$data = SbRespFollowTopButton_user;
export type SbRespFollowTopButton_user$key = {
    readonly " $data"?: SbRespFollowTopButton_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespFollowTopButton_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespFollowTopButton_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchTypes",
      "type": "[types]"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "favorites",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Variable",
          "name": "pages",
          "variableName": "followSearchPages"
        },
        {
          "kind": "Variable",
          "name": "types",
          "variableName": "followSearchTypes"
        }
      ],
      "concreteType": "favoritesConnection",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FollowButton_favoritesConnection",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'fbd99f4fb8eee2fd288b7ba28ed992ec';
export default node;
